import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSCornTortillaProduct from 'models/BSCornTortillaProduct'
import CornTortillaPackage from './CornTortillaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  packagingInfo: <CornTortillaPackage />,
  productTitle: 'Brand Specific Corn Tortillas (Soft)',
  model: BSCornTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['007BS'],
  brandSpecific: true,
}

const BSCornTortilla = () => <ProductForm product={productOptions} />

export default BSCornTortilla

export const getBSCornTortillaPackage = newProduct => {
  const newBSCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSCornTortillaPackage
}

export const updateBSCornTortillaPackage = newProduct => {
  const newBSCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSCornTortillaPackage
}
